<div *ngIf="isSnapShotReport" style="display: inline; align-items: flex-start;" data-cy="financial-snapshot-filters-snapshot">
  <mat-grid-list cols="3" rowHeight="26px" class="grid-list-container" data-cy="financial-snapshot-filters-grid">
      <mat-grid-tile [colspan]="3" [rowspan]="1" class="mat-grid-tile-container" data-cy="financial-snapshot-filters-report-for-header">
        <p style="font-weight: bolder; padding-top: 10px; margin-right: auto" data-cy="financial-snapshot-filters-report-for-title">Report For</p>
      </mat-grid-tile>
      <mat-radio-group aria-label="Report For" data-cy="financial-snapshot-filters-report-for-group">
        <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container" data-cy="financial-snapshot-filters-provider-radio-container">
          <mat-radio-button value=true (change)="radioChangeReportFor($event)" style="margin-left: 5px" data-cy="financial-snapshot-filters-provider-radio">Provider</mat-radio-button>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container" data-cy="financial-snapshot-filters-provider-select-container">
          <div *ngIf="isReportForProvide" style="width: 100%" data-cy="financial-snapshot-filters-provider-select-wrapper">
            <mat-form-field floatLabel="auto" style="width: 100%; background-color: white; border-radius: 8px;" data-cy="financial-snapshot-filters-provider-form-field">
              <mat-select [formControl]="doctor" required data-cy="financial-snapshot-filters-provider-select">
                <mat-option (onSelectionChange)="onDoctorSelect(doctor,$event)" *ngFor="let doctor of staticDataService.currentLocationDoctors" [value]="doctor" [attr.data-cy]="'financial-snapshot-filters-provider-option-' + doctor.dataContact.LastName.toLowerCase()">
                  {{doctor.dataContact.FirstName}} {{doctor.dataContact.LastName}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container" data-cy="financial-snapshot-filters-practice-radio-container">
          <mat-radio-button value=false [checked]="true" (change)="radioChangeReportFor($event)" style="margin-left: 5px" data-cy="financial-snapshot-filters-practice-radio">Practice</mat-radio-button>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container" data-cy="financial-snapshot-filters-practice-dropdown-container">
          <div *ngIf="!isReportForProvide" style="width: 100%" data-cy="financial-snapshot-filters-practice-dropdown-wrapper">
            <app-tdo-dropdown
                              [dataSource]="clientList"
                              dataSourceDisplayKey="Name"
                              [isObjectValue]="true"
                              [value]="selectedClient"
                              (selectionChange)="onChangeClient($event)"
                              data-cy="financial-snapshot-filters-practice-dropdown">
            </app-tdo-dropdown>
          </div>
        </mat-grid-tile>
      </mat-radio-group>
  </mat-grid-list>
</div>

<div *ngIf="!isSnapShotReport" style="display: inline; align-items: flex-start;" data-cy="financial-snapshot-filters-nonsnapshot">
    <mat-grid-list cols="3" rowHeight="26px" class="grid-list-container" data-cy="financial-snapshot-filters-nonsnapshot-grid">
      <mat-grid-tile [colspan]="3" [rowspan]="1" class="mat-grid-tile-container" data-cy="financial-snapshot-filters-nonsnapshot-report-for-header">
        <p style="font-weight: bolder; padding-top: 10px; margin-right: auto" data-cy="financial-snapshot-filters-nonsnapshot-report-for-title">Report For</p>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container" data-cy="financial-snapshot-filters-nonsnapshot-provider-label">
        <p style="margin-left: 5px" data-cy="financial-snapshot-filters-nonsnapshot-provider-text">Provider</p>
      </mat-grid-tile>
        <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container" data-cy="financial-snapshot-filters-nonsnapshot-provider-dropdown-container">
          <div style="width: 100%;" data-cy="financial-snapshot-filters-nonsnapshot-provider-dropdown-wrapper">
            <tdo-dropdown-v2
              [isMultiSelect]="true"
              [isIncludeAll]="true"
              [isPreventMouseEventPropagation]="true"
              [datasource]="staticDataService.currentLocationDoctors" [displayPredicate]="doctorPredicate"
              [value]="selectedProviders"
              (selectionChange)="onDoctorsSelected($event)"
              (closed)="onDoctorsSelected($event)"
              data-cy="financial-snapshot-filters-nonsnapshot-provider-dropdown">
            </tdo-dropdown-v2>
          </div>
        </mat-grid-tile>
      <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container" data-cy="financial-snapshot-filters-nonsnapshot-snapshot-label">
        <p style="margin-left: 5px" data-cy="financial-snapshot-filters-nonsnapshot-snapshot-text">Snapshot</p>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container" data-cy="financial-snapshot-filters-nonsnapshot-snapshot-dropdown-container">
        <app-tdo-dropdown style="width: 100%"
                          [dataSource]="filterRSFSnapshotTypeEnums"
                          dataSourceDisplayKey="ItemDisplayValue"
                          [isObjectValue]="true"
                          [value]="selectedSnapshotType"
                          (selectionChange)="onChangeSnapshotType($event)" required
                          data-cy="financial-snapshot-filters-nonsnapshot-snapshot-dropdown">
        </app-tdo-dropdown>
      </mat-grid-tile>
    </mat-grid-list>
</div>
<div *ngIf="!isDailySnapShot" style="display: inline; align-items: flex-start; width: 100%" data-cy="financial-snapshot-filters-date-range">
  <mat-grid-list cols="3" rowHeight="31px" class="grid-list-container" data-cy="financial-snapshot-filters-date-range-grid">
    <mat-grid-tile [colspan]="3" [rowspan]="1" class="mat-grid-tile-container" data-cy="financial-snapshot-filters-date-range-header">
      <p style="font-weight: bolder; padding-top: 10px; margin-right: auto" data-cy="financial-snapshot-filters-date-range-title">Date Range</p>
    </mat-grid-tile>
    <mat-grid-tile [colspan]="1" [rowspan]="1" class="mat-grid-tile-container" data-cy="financial-snapshot-filters-date-range-spacer">
    </mat-grid-tile>
    <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container" data-cy="financial-snapshot-filters-date-range-dropdown-container">
      <app-tdo-dropdown placeholder="Select Date Range"
                        style="width: 100%"
                        [dataSource]="filterDateRangesEnums"
                        dataSourceDisplayKey="ItemDisplayValue"
                        [isObjectValue]="true"
                        [value]="selectedDateRanges"
                        (selectionChange)="onChangeDateRanges($event)"
                        data-cy="financial-snapshot-filters-date-range-dropdown">
      </app-tdo-dropdown>
    </mat-grid-tile>
  </mat-grid-list>
</div>
<div *ngIf="!isDailySnapShot" style="display: inline; align-items: flex-start; width: 100%; height: 55px;" data-cy="financial-snapshot-filters-date-picker">
  <mat-grid-list cols="3" rowHeight="55px" class="grid-list-container" data-cy="financial-snapshot-filters-date-picker-grid">
    <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container" data-cy="financial-snapshot-filters-date-picker-spacer">
    </mat-grid-tile>
    <mat-grid-tile [colspan]="2" [rowspan]="2" class="mat-grid-tile-container" data-cy="financial-snapshot-filters-date-picker-container">
      <mat-form-field appearance="fill" class="example-form-field" style="width: 100%" data-cy="financial-snapshot-filters-date-picker-form-field">
        <mat-label data-cy="financial-snapshot-filters-date-picker-label">Enter a date range</mat-label>
        <mat-date-range-input [rangePicker]="rangePicker" data-cy="financial-snapshot-filters-date-picker-input">
          <input matStartDate placeholder="Start date" [(ngModel)]="startDate" disabled="false" data-cy="financial-snapshot-filters-date-picker-start">
          <input matEndDate placeholder="End date" [(ngModel)]="endDate" disabled="false" data-cy="financial-snapshot-filters-date-picker-end">
        </mat-date-range-input>
        <mat-hint data-cy="financial-snapshot-filters-date-picker-hint">MM/DD/YYYY – MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="rangePicker" data-cy="financial-snapshot-filters-date-picker-toggle"></mat-datepicker-toggle>
        <mat-date-range-picker #rangePicker data-cy="financial-snapshot-filters-date-range-picker">
          <mat-date-range-picker-actions data-cy="financial-snapshot-filters-date-picker-actions">
            <button mat-button matDateRangePickerCancel data-cy="financial-snapshot-filters-date-picker-cancel">Cancel</button>
            <button mat-raised-button color="primary" matDateRangePickerApply (click)="UserDefined()" data-cy="financial-snapshot-filters-date-picker-apply">Apply</button>
          </mat-date-range-picker-actions>
        </mat-date-range-picker>
      </mat-form-field>
    </mat-grid-tile>
  </mat-grid-list>
</div>

<div style="display: inline; align-items: flex-start; width: 100%" data-cy="financial-snapshot-filters-order-by">
  <mat-grid-list cols="4" rowHeight="26px" class="grid-list-container" data-cy="financial-snapshot-filters-order-by-grid">
    <mat-grid-tile [colspan]="4" [rowspan]="1" class="mat-grid-tile-container" data-cy="financial-snapshot-filters-order-by-header">
      <p style="font-weight: bolder; padding-top: 10px; margin-right: auto" data-cy="financial-snapshot-filters-order-by-title">Order By</p>
    </mat-grid-tile>
    <mat-radio-group aria-label="Order By" data-cy="financial-snapshot-filters-order-by-group">
      <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container" data-cy="financial-snapshot-filters-order-asc-container">
        <mat-radio-button value=true [checked]="true" (change)="radioChange($event)" style="margin-left: 5px" data-cy="financial-snapshot-filters-order-asc">Asc</mat-radio-button>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="1" [rowspan]="2" class="mat-grid-tile-container" data-cy="financial-snapshot-filters-order-desc-container">
        <mat-radio-button value=false (change)="radioChange($event)" data-cy="financial-snapshot-filters-order-desc">Desc</mat-radio-button>
      </mat-grid-tile>
    </mat-radio-group>
    <mat-grid-tile  *ngIf="!isSnapShotReport" [colspan]="2" [rowspan]="2" class="mat-grid-tile-container" data-cy="financial-snapshot-filters-order-nonsnapshot-container">
      <app-tdo-dropdown *ngIf="!isSnapShotReport"
                        style="width: 100%;"
                        [dataSource]="orderByOption"
                        dataSourceDisplayKey="viewValue"
                        [isObjectValue]="true"
                        [value]="selectedOrderByOption"
                        (selectionChange)="onChangeOrderByOption($event)" required
                        data-cy="financial-snapshot-filters-order-nonsnapshot-dropdown">
      </app-tdo-dropdown>
    </mat-grid-tile>
    <mat-grid-tile *ngIf="isSnapShotReport" [colspan]="2" [rowspan]="2" class="mat-grid-tile-container" data-cy="financial-snapshot-filters-order-snapshot-container">
      <app-tdo-dropdown *ngIf="isSnapShotReport"
                        style="width: 100%;"
                        [dataSource]="orderByOptionDaily"
                        dataSourceDisplayKey="viewValue"
                        [isObjectValue]="true"
                        [value]="selectedSnapShotOrderBy"
                        (selectionChange)="onChangeOrderByOptionDaily($event)" required
                        data-cy="financial-snapshot-filters-order-snapshot-dropdown">
      </app-tdo-dropdown>
    </mat-grid-tile>
    <mat-grid-tile *ngIf="isSnapShotReport" [colspan]="4" [rowspan]="1" class="mat-grid-tile-container" data-cy="financial-snapshot-filters-misc-header">
      <p style="font-weight: bolder; padding-top: 10px; margin-right: auto" data-cy="financial-snapshot-filters-misc-title">Miscellaneous</p>
    </mat-grid-tile>
    <mat-grid-tile [colspan]="4" [rowspan]="2" class="mat-grid-tile-container" data-cy="financial-snapshot-filters-interactive-container">
      <div *ngIf="isSnapShotReport" style="padding-left: 22px; margin-right: auto" data-cy="financial-snapshot-filters-interactive-wrapper">
        <section data-cy="financial-snapshot-filters-interactive-section">
          <mat-checkbox id="isInteractiveReport" checked="true" [formControl]="checkboxSnapShotReport" (change)="toggle($event)" data-cy="financial-snapshot-filters-interactive-checkbox">Show Interactive Report</mat-checkbox>
        </section>
      </div>
    </mat-grid-tile>
    <mat-grid-tile [colspan]="4" [rowspan]="2" class="mat-grid-tile-container" data-cy="financial-snapshot-filters-inactive-container">
      <div *ngIf="isSnapShotReport" style="padding-left: 22px; margin-right: auto" data-cy="financial-snapshot-filters-inactive-wrapper">
        <section data-cy="financial-snapshot-filters-inactive-section">
          <mat-checkbox id="showInactive" [formControl]="checkboxShowActiveDoctors" (change)="showInactiveDoc($event)" data-cy="financial-snapshot-filters-inactive-checkbox">Show Inactive Doctors</mat-checkbox>
        </section>
      </div>
    </mat-grid-tile>
  </mat-grid-list>
</div>
